
import vue from 'vue'
import {
initWxJSSDK,
getSignList,
getTerminalList,
manualSign
} from '../../common/js/api.js'
import Scroller from 'vux/src/components/scroller/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
directives: {
TransferDom
},
components: {
Scroller,
XHeader,
XInput,
XTextarea,
XButton,
Box,
Group,
CellBox,
TransferDom,
Popup,
Picker,
PopupPicker,
Cell
},
data() {
return {
isOpenTerminalPicker: false,
terminalName: '',
isPopup: false,
lngLat: null,
entity: {},
terminals: [],
view: {
loading: false,
firstLoad: true
},
status: {
pullupStatus: 'default',
pulldownStatus: 'default'
},
pullupConfig: {
content: '上拉加载更多',
downContent: '松开进行加载',
upContent: '上拉加载更多',
loadingContent: '加载中...'
},
pulldownConfig: {
content: '下拉刷新',
downContent: '下拉刷新',
upContent: '释放刷新',
loadingContent: '加载中...'
},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: '',
extInfo: { status: undefined },
payType: 0
},
disabled:
typeof navigator !== 'undefined' &&
/iphone/i.test(navigator.userAgent) &&
/ucbrowser/i.test(navigator.userAgent),
list: []
}
},
methods: {
refresh() {
let self = this
self.pageInfo.pageIndex = 1
self.getList()
},
loadMore() {
let self = this
self.pageInfo.pageIndex++
self.getList()
},

getList() {
let self = this
getSignList({ data: this.pageInfo }).then(function(data) {
self.view.firstLoad = false
if (data.PageIndex > 1) {
self.list = self.list.concat(data.Content)
} else {
self.list = data.Content
}
if (data.Content.length == self.pageInfo.pageSize) {
self.$refs.scroller.enablePullup()
} else {
self.$refs.scroller.disablePullup()
}
setTimeout(() => {
self.$refs.scroller.donePullup()
self.$refs.scroller.donePulldown()
}, 50)
})
},
openManual() {
let self = this
this.isPopup = true
initWxJSSDK()
vue.wechat.ready(function(res) {
self.initLocation()
})

getTerminalList().then(function(data) {
self.terminals = data.Content
})
},
initLocation() {
let self = this
self.$wechat.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res)
},
success: function(res) {
var latitude = res.latitude 
var longitude = res.longitude 
var speed = res.speed 
var accuracy = res.accuracy 
if ((latitude + '').length > 13) {
latitude = parseFloat(latitude).toFixed(10)
}
if ((longitude + '').length > 13) {
longitude = parseFloat(longitude).toFixed(10)
}
self.lngLat = longitude + ',' + latitude
self.entity.longitude = longitude
self.entity.latitude = latitude
}
})
},
pickTerminal(item) {
let self = this
self.isOpenTerminalPicker = false
self.entity.sid = item.sid
self.terminalName = '编号:' + item.terminalId + ',' + item.location
},
sign() {
let self = this
if (!self.entity.latitude) {
self.$vux.toast.text('定位尚未完成')
return
}
if (!self.entity.sid) {
self.$vux.toast.text('请选择回收箱')
return
}
manualSign({ data: self.entity }).then(function(data) {
self.$vux.toast.text('签到成功！')
self.isPopup = false
self.refresh()
})

}
},
mounted() {
this.getList()
}
}



// WEBPACK FOOTER //
// ./src/components/support/SignList.vue